export const SEVERITY_COLORS = {
  CRITICAL: {
    main: '#F3786F',
    icon: '#FEFEFE',
    circle: '#F3786F',
    text: '#615E6F',
  },
  IMPORTANT: {
    main: '#FFB054',
    icon: '#FEFEFE',
    circle: '#FFC959',
    text: '#615E6F',
  },
  COMMON: {
    main: '#4592fa',
    icon: '#FEFEFE',
    circle: '#4592fa',
    text: '#615E6F',
  },
} as const;

export type SeverityType = keyof typeof SEVERITY_COLORS;

export const SEVERITY_ACCENT_COLORS: Record<SeverityType, string> = {
  CRITICAL: '#e9554a',
  IMPORTANT: '#ffb147',
  COMMON: '#4592fa',
};

export const SEVERITY_CONFIG: Array<{ severity: SeverityType; label: string }> = [
  { severity: 'CRITICAL', label: 'notifications.severity.critical' },
  { severity: 'IMPORTANT', label: 'notifications.severity.important' },
  { severity: 'COMMON', label: 'notifications.severity.common' },
];
